import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RechargeModel, TopupSearchData } from "./InitialStatePropsModel";

const initialState: RechargeModel = {
    searchData: {} as TopupSearchData,
    isTopupSectionView: false
}

const RechargeSlice = createSlice({
    name: "RechargeSlice",
    initialState,
    reducers: {
        setTopupSectionView(state: RechargeModel, action: PayloadAction<boolean>) {
            state.isTopupSectionView = action.payload;
        },
        setSearchData(state: RechargeModel, action: PayloadAction<TopupSearchData>) {
            state.searchData = action.payload;
        },
    }
});
export const { setTopupSectionView, setSearchData } = RechargeSlice.actions;
export default RechargeSlice;